import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { GhostButtonComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-button/ghost-button.component';
import { GhostMediaComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-media/ghost-media.component';
import { GhostParagraphModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-paragraph';
import { GhostTitleModule } from '@x/ecommerce-shop/app/core/shop-ui/components/ghost-loading/ghost-title';
import { GhostProductMediaModule } from 'apps/ecommerce-shop/src/app/core/shop-ui/components/ghost-loading/ghost-product-media';

@Component({
  selector: 'x-ghost-section-with-image',
  standalone: true,
  imports: [
    GhostProductMediaModule,
    GhostTitleModule,
    GhostParagraphModule,
    GhostButtonComponent,
    GhostMediaComponent,
  ],
  templateUrl: './ghost-section-with-image.component.html',
  styleUrl: './ghost-section-with-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GhostSectionWithImageComponent {
  @Input() reverse = false;
}
